import React from 'react'
import ReactDOM from 'react-dom';
import {compose, withState} from 'recompose'
import styled from 'styled-components'
import EyeImage from '../static/eye.svg'

const Img = styled.img`
  cursor: pointer;
  transition: all .3s ease;
`

const Cross = styled.div`
  color: rgba(0,0,0,0.5);
  height: 25px;
  width: 25px;
  font-size: 24px;
  position: absolute;
  right: 15px;
  top: 15px;

  &:hover {
    color: black;
  }
`

const modalRoot = document.getElementById('modal');

const Zoomed = ({src, setZoomed, padding}) => (
  <div
    onClick={() => {
      setZoomed(false)
    }}
    style={{
      position: 'fixed',
      cursor: 'pointer',
      zIndex: 1000,
      background: 'rgba(0,0,0,0.6)',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      justifyContent: 'center',
    }}
  >
    <div
      style={{
        maxHeight: '80%',
        maxWidth: '70%',
        background: 'white',
        position: 'relative',
        textAlign: 'center',
        padding: padding,
      }}
    >
      <Cross>×</Cross>
      <img
        onClick={(e) => {
          e.stopPropagation();
        }}
        src={src}
        style={{
          cursor: 'auto',
          maxHeight: '100%',
          maxWidth: '100%',
          padding: 20,
        }}
      />
    </div>
  </div>
)

const ZoomableImage = ({src, width, height, style, className, hover, setHover, zoomed, setZoomed, containerStyle, padding}) => (
  <div
    style={{
      position: 'relative',
      display: 'inline-block',
      ...(containerStyle && containerStyle),
    }}
    onMouseOver={() => {
      setHover(true)
    }}
    onMouseOut={() => {
      setHover(false)
    }}
  >
    <Img
      className={className}
      hover={hover}
      src={src}
      onClick={() => {
        setZoomed(!zoomed)
      }}
      style={{
        ...(width && {width}),
        ...(height && {height}),
        ...(style && style),
      }}
    />
    <Img
      hidden={!hover}
      src={EyeImage}
      onClick={() => {
        setZoomed(!zoomed)
      }}
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1
      }}
    />
    {
      zoomed &&
      <Portal>
        <Zoomed
          padding={padding}
          src={src}
          setZoomed={() => {
            setZoomed(false);
            setHover(false);
          }}
        />
      </Portal>
    }
  </div>
)

function Portal(props) {
  return (
    ReactDOM.createPortal(
      props.children,
      modalRoot,
    )
  )
}

export default
  compose(
    withState('hover', 'setHover', false),
    withState('zoomed', 'setZoomed', false),
  )
  (ZoomableImage)



// WEBPACK FOOTER //
// ./src/basic/ZoomableImage.js